import { Helmet } from 'react-helmet-async';
import { createOfferCatalogSchema } from './schemaHelpers';

export function OrganizationSchema() {
  const offerCatalog = createOfferCatalogSchema();
  // Remove @context from nested catalog since parent has it
  const { "@context": _, ...catalogWithoutContext } = offerCatalog;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AI ToolHub",
    "alternateName": "AIToolHub",
    "url": "https://aitoolhub.ai",
    "logo": "https://aitoolhub.ai/favicon.png",
    "description": "Explore 500+ curated AI tools with expert reviews, pricing, alternatives, and side-by-side comparisons — find the perfect AI tool for any task.",
    "foundingDate": "2024",
    "parentOrganization": {
      "@type": "Organization",
      "name": "Next Mind Digital Artificial Intelligence Developing Services",
      "url": "https://nextminddigital.com"
    },
    "sameAs": [
      "https://twitter.com/AIToolHub",
      "https://linkedin.com/company/aitoolhub"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "hello@aitoolhub.ai",
      "url": "https://aitoolhub.ai/contact"
    },
    "areaServed": "Worldwide",
    "knowsLanguage": ["en", "ar"],
    "knowsAbout": [
      "Artificial Intelligence",
      "AI Tools",
      "Machine Learning",
      "AI Software",
      "Vibe Coding",
      "AI Development"
    ],
    "hasOfferCatalog": catalogWithoutContext
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
